import { cx, styled } from "simplydo/react/styled";

import type { MessageContentProps } from "./Message.types";

const ContentEl = styled.div`
  clear: both;
  flex: 1;
  min-width: 0;
`;

const MessageContentComponent = (props: MessageContentProps) => {
  const { children, className, style } = props;
  return (
    <ContentEl className={cx(className)} style={style}>
      {children}
    </ContentEl>
  );
};

export const MessageContent = styled(MessageContentComponent)``;
